import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
} from "./apilogSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  formatDateTime,
  paramsStatusCrash,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Mengimpor ikon dari react-icons

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchRole, selectRole } from "../role/roleSlice";
import JSONPretty from "react-json-pretty";
import { CopyToClipboard } from "react-copy-to-clipboard";

export const ApilogCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataRole = useSelector(selectRole);

  const { id } = useParams();

  const [status, setStatus] = useState("");
  const [remarks, setRemarks] = useState("");
  const paramsId = {
    id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setStatus(dataId?.status);
      setRemarks(dataId?.resolved_remarks);
    }
  }, [dataId]);

  const handleChangeStatus = createChangeHandler(setStatus);

  const handleSave = async () => {
    const params = {
      ...dataId,
      cras_id: id,
      status: status,
      resolved_remarks: remarks,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => setShow(false);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Apilog " : "View Apilog "}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>username</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.username}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" value={dataId?.name} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Branch</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.branch_name}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Method</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" value={dataId?.method} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>View data</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Button
                      className="btn btn-outline-danger"
                      onClick={(e) => handleShow()}
                    >
                      View
                    </Button>
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Status</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" value={dataId?.status} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.status_code}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Remark</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" value={dataId?.remark} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Data</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "650px", overflowY: "auto" }}>
          <Row>
            <Col md="6">
              <div className="d-flex justify-content-between align-items-center">
                <h2>Request Data</h2>
                <CopyToClipboard
                  text={dataId?.req_data}
                  onCopy={() => setCopied(true)}
                >
                  <Button className="btn btn-outline-danger btn-small">
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
              {/* {copied ? <span style={{ color: "red" }}>Copied.</span> : null} */}

              <JSONPretty id="json-pretty" data={dataId?.req_data}></JSONPretty>
            </Col>
            <Col md="6">
              <div className="d-flex justify-content-between align-items-center">
                <h2>Response Data</h2>
                <CopyToClipboard
                  text={dataId?.response_data}
                  onCopy={() => setCopied(true)}
                >
                  <Button className="btn btn-outline-danger btn-small">
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
              <JSONPretty
                id="json-pretty"
                data={dataId?.response_data}
              ></JSONPretty>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="mr-3" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
